import { useQueryClient, useMutation } from '@tanstack/react-query';
import { updateCachedProgress } from '../utils';
export const useProgressItemMutation = () => {
    const client = useQueryClient();
    return useMutation({
        mutationFn: async (variables) => {
            updateCachedProgress(client, variables);
        },
    });
};
//# sourceMappingURL=useProgressItemMutation.js.map